import React, { useContext, useState } from 'react'
import { CardBody, Col, Input, Label, Row } from 'reactstrap'
import CommonModal from "../../UiKits/Modals/common/modal";
import { quizValidateData } from '../../../utils/validate'
import { Dropdowns } from '../../../AbstractElements'
import { showAlert } from '../../../utils/alert';
import { MoreVertical } from 'react-feather'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import { deleteQuizCategory, updateQuizCategory, updateQuizStatus } from '../../../firebase/utils';
import QuizContext from '../../../Helper/Quiz';

const QuizAction = ({ data, categoryId, setData, mainData, setIsUpdatingQuizStatus }) => {
  const { fetchQuiz } = useContext(QuizContext)
  const navigate = useNavigate()
  const [show, setShow] = useState(false)
  const [open, setOpen] = useState(false)
  const [review, setReview] = useState(data.showReview)
  const [quizData, setQuizData] = useState(data)

  const reviewHandler = async () => {
    const currQuiz = mainData.find((main) => main.id === categoryId)
    await updateQuizCategory({ showReview: !review }, categoryId, data.id)
    const quizzes = currQuiz.quizzes.map((quiz) => quiz.id === data.id ? { ...quiz, showReview: review } : quiz)
    setData(prevState => prevState.map(obj =>
      obj.id === categoryId ? { ...obj, quizzes: quizzes } : obj
    ))
    setShow(false)
    toast.success('Review updated successfully')
  }

  const inputChangeHandler = (e) => {
    setQuizData({
      ...quizData,
      [e.target.name]: e.target.value
    })
  }

  const updateCategory = async () => {
    if (quizValidateData(quizData)) {
      const quizUpdatedData = {
        Duration: quizData.Duration,
        name: quizData.name,
        password: quizData.password,
      }
      const currQuiz = mainData.find((main) => main.id === categoryId)
      await updateQuizCategory(quizUpdatedData, categoryId, quizData.id)
      const quizzes = currQuiz.quizzes.map((quiz) => quiz.id === quizData.id ? { ...quiz, ...quizUpdatedData } : quiz)
      setData(prevState => prevState.map(obj =>
        obj.id === categoryId ? { ...obj, quizzes: quizzes } : obj
      ))
      toast.success('Quiz Updated sucessfully')
      setOpen(false)
    } else {
      toast.error('Please enter all the fields')
    }
  }

  const deleteCategory = async () => {
    const warningText = `Are you sure you want to delete 
    ${data.name} quiz?`
    const isConfirm = await showAlert(warningText, 'Delete')
    if (isConfirm) {
      await deleteQuizCategory(categoryId, data.id)
      const currQuiz = mainData.find((main) => main.id === categoryId)
      const quizzes = currQuiz.quizzes.filter((quiz) => quiz.id !== data.id)
      setData(prevState => prevState.map(obj =>
        obj.id === categoryId ? { ...obj, quizzes: quizzes } : obj
      ))
      toast.success('Category Deleted Successfully')
    }
  }

  const navigateToQuizQuestion = () => {
    navigate(`/quiz/${categoryId}/questions/${data.id}`)
    fetchQuiz(categoryId, data.id)
  }

  const handleStatusChange = async (categoryID, quizID, newStatus) => {
    const confirmation = await showAlert(`You want to change the ${data.name} status to "${newStatus}"?`, 'Change Status')
    if (!confirmation) return;

    try {
      setIsUpdatingQuizStatus({ id: quizID, isLoading: true });

      await updateQuizStatus(categoryID, quizID, newStatus);

      setData((prevData) =>
        prevData.map((quizGroup) => {
          const updatedQuizzes = quizGroup.quizzes.map((q) =>
            q.id === quizID ? { ...q, status: newStatus } : q
          );
          return { ...quizGroup, quizzes: updatedQuizzes };
        })
      );

      toast.success("Updated quiz status successfully");
    } catch (error) {
      console.error("Error updating quiz status:", error);
      toast.error("Failed to update quiz status");
    } finally {
      setIsUpdatingQuizStatus({ id: '', isLoading: false });
    }
  };

  const copyPublicUrl = () => {
    const baseUrl = "https://portal.expertizouniversity.pk";
    const quizURL = `public-quiz/${data.id}`;
    const quizPublicURL = `${baseUrl}/${quizURL}`;
    navigator.clipboard.writeText(quizPublicURL)
    toast.success('Public URL copied to clipboard')
  }

  const actionOptions = [
    ...(data?.status === 'Public'
      ? [{
        item: 'Copy Public URL',
        onClick: () => copyPublicUrl()
      }]
      : []),
  {
    item: 'Change Status',
    onClick: () => handleStatusChange(categoryId, data?.id, data?.status && data?.status === 'Public' ? 'Private' : 'Public')
  },
  {
    item: data.showReview ? 'Close Review' : 'Open Review',
    onClick: () => reviewHandler()
  },
  {
    item: 'Edit Category',
    onClick: () => setOpen(true)
  },
  {
    item: 'Delete Category',
    onClick: () => deleteCategory()
  },
  {
    item: 'View Questions',
    onClick: () => navigateToQuizQuestion()
  },

  ]
  return (
    <CardBody className="dropdown-basic p-0 fee-table-action">
      <Dropdowns
        attrDropBtn={{ className: 'dropbtn table-action', id: 'UncontrolledPopover' }}
        attrDropMenu={{ className: 'dropdown-content module-dropdown' }}
        dropItem={actionOptions}
        dropBtnContent={<MoreVertical className="dropbtn" />}
        attrDropItem={{
          toggle: false,
        }}
      />
      {open && <CommonModal
        isOpen={open}
        toggler={() => {
          setOpen(false)
        }}
        successText='Update'
        title='Update Quiz'
        success={updateCategory}
      >
        <div>
          <Label htmlFor='name' className='f-w-500'>Quiz Name</Label>
          <Input id='name' name='name' value={quizData.name} onChange={inputChangeHandler} />
        </div>
        <div className='m-t-10'>
          <Row>
            <Col md={6}>
              <Label htmlFor='duration' className='f-w-500'>Quiz Duration</Label>
              <Input id='duration' type='number' name='Duration' value={quizData.Duration} onChange={inputChangeHandler} />

            </Col>
            <Col md={6}>
              <Label htmlFor='password' className='f-w-500'>Quiz Password</Label>
              <Input id='password' name='password' value={quizData.password} onChange={inputChangeHandler} />
            </Col>
          </Row>
        </div>
      </CommonModal>}
    </CardBody>
  )
}

export default QuizAction
